import request from "../utils/request";

// dropOff/refundTotalFee
export function refundTotalFee() {
  return request({
    url: '/dropOff/refundTotalFee',
    method: 'get',
  })
}

// dropOff/account/isActive
export function isActiveDropoff(data) {
  return request({
    url: '/dropOff/account/isActive',
    method: 'get',
    params: data
  })
}

// dropOff/account/isReadNotice
export function isReadNoticeDropoff(data) {
  return request({
    url: '/dropOff/account/isReadNotice',
    method: 'get',
    params: data
  })
}

// oan/loanAgentBankInfo/getCommissionAccount
export function getCommissionAccount() {
  return request({
    url: '/loan/loanAgentBankInfo/getCommissionAccount',
    method: 'get',
  })
}

// dropOff/account/agreementStatus
export function getAgreementStatus() {
  return request({
    url: '/dropOff/account/agreementStatus',
    method: 'get',
  })
}

// dropOff/queryDropOffList
export function queryDropOffList(data) {
  return request({
    url: '/dropOff/queryDropOffList',
    method: 'post',
    data
  })
}

// dropOff/lazada/updatePkgStatus
export function updatePkgStatus(data) {
  return request({
    url: '/dropOff/lazada/updatePkgStatus',
    method: 'post',
    data
  })
}

// agentAgreement
export function agentAgreement(data) {
  return request({
    url: '/agentAgreement',
    method: 'get',
    params: data
  })
}

//dropOffSettleDetail/income get
export function getIncome(data) {
  return request({
    url: '/dropOffSettleDetail/income',
    method: 'get',
    params: data
  })
}

// dropOffSettleDetail/queryList
export function DropOffSettleDetailQueryList(data) {
  return request({
    url: '/dropOffSettleDetail/queryList',
    method: 'post',
    data
  })
}

// excel/exportExcelUrl
export function exportExcelUrl(data) {
  return request({
    url: '/excel/exportExcelUrl',
    method: 'post',
    data
  })
}

// dropOffSettleDetail/queryDetailList
export function queryDetailList(data) {
  return request({
    url: '/dropOffSettleDetail/queryDetailList',
    method: 'post',
    data
  })
}

// dropoffagentpayment/queryFineBillList
export function queryFineBillList(data) {
  return request({
    url: '/dropoffagentpayment/queryFineBillList',
    method: 'post',
    data
  })
}

// dropofforder/queryBillDetailList
export function queryBillDetailList(data) {
  return request({
    url: '/dropofforder/queryBillDetailList',
    method: 'post',
    data
  })
}

// dropoffagentpayment/pay
export function payFineBill(data) {
  return request({
    url: '/dropoffagentpayment/pay',
    method: 'post',
    data
  })
}
